export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13610.7e6f9cd6.jpg";